import { Locales } from '../types'

// Translations that are common to two or more products
export default {
  [Locales.GB]: {
    customiseColumns: 'Customise columns',
    clickAndDragColumns: 'Click and drag columns in the table to re-arrange them',
  },
}
